/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Last_4_Weeks_InternalInputs */

const en_admin_dashboard_last_4_weeks_internal = /** @type {(inputs: Admin_Dashboard_Last_4_Weeks_InternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last 4 weeks Internal`)
};

const de_admin_dashboard_last_4_weeks_internal = /** @type {(inputs: Admin_Dashboard_Last_4_Weeks_InternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzte 4 Wochen intern`)
};

const es_admin_dashboard_last_4_weeks_internal = /** @type {(inputs: Admin_Dashboard_Last_4_Weeks_InternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Últimas 4 semanas internas`)
};

const fr_admin_dashboard_last_4_weeks_internal = /** @type {(inputs: Admin_Dashboard_Last_4_Weeks_InternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4 dernières semaines internes`)
};

const nl_admin_dashboard_last_4_weeks_internal = /** @type {(inputs: Admin_Dashboard_Last_4_Weeks_InternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laatste 4 weken intern`)
};

const it_admin_dashboard_last_4_weeks_internal = /** @type {(inputs: Admin_Dashboard_Last_4_Weeks_InternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultime 4 settimane interne`)
};

const pt_br2_admin_dashboard_last_4_weeks_internal = /** @type {(inputs: Admin_Dashboard_Last_4_Weeks_InternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Últimas 4 semanas internas`)
};

const pl_admin_dashboard_last_4_weeks_internal = /** @type {(inputs: Admin_Dashboard_Last_4_Weeks_InternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ostatnie 4 tygodnie wewnętrzne`)
};

const hu_admin_dashboard_last_4_weeks_internal = /** @type {(inputs: Admin_Dashboard_Last_4_Weeks_InternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utolsó 4 hét belső`)
};

const ro_admin_dashboard_last_4_weeks_internal = /** @type {(inputs: Admin_Dashboard_Last_4_Weeks_InternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultimele 4 saptamani Intern`)
};

/**
* | output |
* | --- |
* | "Last 4 weeks Internal" |
*
* @param {Admin_Dashboard_Last_4_Weeks_InternalInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_last_4_weeks_internal = /** @type {((inputs?: Admin_Dashboard_Last_4_Weeks_InternalInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Last_4_Weeks_InternalInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_last_4_weeks_internal(inputs)
	if (locale === "de") return de_admin_dashboard_last_4_weeks_internal(inputs)
	if (locale === "es") return es_admin_dashboard_last_4_weeks_internal(inputs)
	if (locale === "fr") return fr_admin_dashboard_last_4_weeks_internal(inputs)
	if (locale === "nl") return nl_admin_dashboard_last_4_weeks_internal(inputs)
	if (locale === "it") return it_admin_dashboard_last_4_weeks_internal(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_last_4_weeks_internal(inputs)
	if (locale === "pl") return pl_admin_dashboard_last_4_weeks_internal(inputs)
	if (locale === "hu") return hu_admin_dashboard_last_4_weeks_internal(inputs)
	return ro_admin_dashboard_last_4_weeks_internal(inputs)
});
export { admin_dashboard_last_4_weeks_internal as "admin.dashboard.last_4_weeks_internal" }